export default __webpack_public_path__ + "static/media/A5_printing_rules_inches.4d9a70e4.pdf";